import { Injectable } from '@angular/core';
import { SnackBarService } from '@app-core/services/snackbar/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DownloadService {
  constructor(private snackbarService: SnackBarService, private translate: TranslateService) {}

  public onDownloadVideos(incident: any): void {
    if (!incident?.mediaFiles || incident.mediaFiles.length === 0) {
      this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      return;
    }

    const mediaFiles = incident.mediaFiles.filter((file) => file?.mediaFile);

    if (mediaFiles.length === 0) {
      this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      return;
    }

    const downloadFile = async (index: number) => {
      if (index >= mediaFiles.length) return;

      const mediaFileUrl = mediaFiles[index].mediaFile;
      if (!mediaFileUrl) {
        console.warn(`Invalid media URL at index ${index}`);
        this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      }

      const fileName = `video_${index + 1}.mp4`;
      const fragment = new DocumentFragment();

      try {
        const a = document.createElement('a');
        a.href = mediaFileUrl;
        a.download = fileName;
        fragment.appendChild(a);
        a.click();
        fragment.removeChild(a);
        setTimeout(() => downloadFile(index + 1), 1000);

        this.snackbarService.success(this.translate.instant('commonIncidentDownloadVideoSuccessfully'));
      } catch (error) {
        console.error('Error downloading video:', error);
        this.snackbarService.failure(this.translate.instant('commonIncidentDownloadVideoFailure'));
      }
    };

    downloadFile(0);
  }
}
